document.addEventListener("DOMContentLoaded", function () {

  const menu = document.getElementById("shop-nav");
  const uglyHeader = document.getElementById("ugly-header");
  const menuLinks = document.querySelectorAll(".header__menu-item");
  const closeBtn = document.getElementById("close-nav");
  const toggle = document.querySelector(".mobile-menu-toggle");
  const inlineMenu = document.querySelector(".header__inline-menu");
  const body = document.body;

  /* Menus that should trigger mobile mega open */
  const mobileMegaIds = [
    "HeaderMenu-shop-all",
    "HeaderMenu-collections",
    "HeaderMenu-eyewear"
  ];

  if (!menu || !menuLinks.length) return;

  let activeLink = null;

  /* ===================================================
     MEGA MENU OPEN (Desktop + Mobile Content Switching)
  =================================================== */

  function openMenu(link) {

    const id = link.id;
    const handle = id.replace("HeaderMenu-", "").toLowerCase();

const titleContainer = document.getElementById("submenu-title");

if (titleContainer) {
  const title = link.querySelector(".menu-title")?.textContent;
  titleContainer.textContent = title ? title.trim() : "";
}

    // Switch submenu content
    document.querySelectorAll(".submenu-content")
      .forEach(menuBlock => menuBlock.classList.remove("active"));

    const activeSubmenu = document.querySelector(
      `.submenu-content[data-menu="${handle}"]`
    );

    if (activeSubmenu) {
      activeSubmenu.classList.add("active");
    }

    // Desktop open styles
    if (window.innerWidth > 767) {
      menu.style.display = "block";
      menu.style.opacity = "1";
      menu.style.height = "auto";
    }

    uglyHeader?.classList.add("open-menu");

    if (activeLink && activeLink !== link) {
      activeLink.classList.remove("menu-open");
    }

    link.classList.add("menu-open");
    activeLink = link;
  }

  function closeMegaMenu() {
    if (window.innerWidth > 767) {
      menu.style.display = "none";
      menu.style.opacity = "0";
      menu.style.height = "0";
    }

    uglyHeader?.classList.remove("open-menu");

    if (activeLink) {
      activeLink.classList.remove("menu-open");
      activeLink = null;
    }

    document.querySelectorAll(".submenu-content")
      .forEach(menuBlock => menuBlock.classList.remove("active"));
  }

  /* ===================================================
     DESKTOP HOVER
  =================================================== */

  menuLinks.forEach(link => {
    link.addEventListener("mouseenter", function () {
      if (window.innerWidth > 767) {
        openMenu(link);
      }
    });
  });

  document.addEventListener("mousemove", function(e) {
    if (window.innerWidth > 767) {
      const isInsideMenu =
        menu.contains(e.target) ||
        inlineMenu?.contains(e.target);

      if (!isInsideMenu) {
        closeMegaMenu();
      }
    }
  });

  /* ===================================================
     MOBILE OPEN (Slide Panel)
  =================================================== */

menuLinks.forEach(link => {

  if (mobileMegaIds.includes(link.id)) {

    // Add class for styling arrow
    link.classList.add("has-mobile-submenu");

    link.addEventListener("click", function(e) {

      if (window.innerWidth <= 767) {

        e.preventDefault();

        openMenu(link);

        menu.classList.add("mobile-open");

      }

    });

  }

});

  /* ===================================================
     MOBILE CLOSE BUTTON (#close-nav)
  =================================================== */

  closeBtn?.addEventListener("click", function() {
    menu.classList.remove("mobile-open");
    closeMegaMenu();
  });

  /* ===================================================
     BURGER TOGGLE
  =================================================== */

  function closeAllMobile() {
    toggle?.classList.remove("active");
    inlineMenu?.classList.remove("active");
    body.classList.remove("menu-open");
    menu.classList.remove("mobile-open");
    closeMegaMenu();
  }

  toggle?.addEventListener("click", function() {

    toggle.classList.toggle("active");
    inlineMenu?.classList.toggle("active");

    if (inlineMenu?.classList.contains("active")) {
      body.classList.add("menu-open");
    } else {
      closeAllMobile();
    }

  });

  /* ===================================================
     CLOSE ON RESIZE
  =================================================== */

  window.addEventListener("resize", function() {
    if (window.innerWidth > 1024) {
      closeAllMobile();
    }
  });

});